var __defProp = Object.defineProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _onContainerKeyDown, _LocalizationFormComponent_instances, findMatches_fn, highlightMatches_fn, changeCountryFocus_fn, _onSearchKeyDown, _onCountryListScroll, _handleClickOutside, _DropdownLocalizationComponent_instances, updateWidth_fn, _handleKeyUp, _onCountryListScroll2;
import { Component } from "@theme/component";
import { isClickedOutside, normalizeString, onAnimationEnd } from "@theme/utilities";
class LocalizationFormComponent extends Component {
  constructor() {
    super(...arguments);
    __privateAdd(this, _LocalizationFormComponent_instances);
    __privateAdd(this, _onContainerKeyDown, (event) => {
      if (event.isComposing || event.altKey || event.ctrlKey || event.metaKey) return;
      const { countryInput, countryListItems, form } = this.refs;
      switch (event.key) {
        case "ArrowUp":
          event.preventDefault();
          event.stopPropagation();
          __privateMethod(this, _LocalizationFormComponent_instances, changeCountryFocus_fn).call(this, "UP");
          break;
        case "ArrowDown":
          event.preventDefault();
          event.stopPropagation();
          __privateMethod(this, _LocalizationFormComponent_instances, changeCountryFocus_fn).call(this, "DOWN");
          break;
        case "Home":
        case "End":
          if (event.target === this.refs.search) return;
          event.preventDefault();
          event.stopPropagation();
          __privateMethod(this, _LocalizationFormComponent_instances, changeCountryFocus_fn).call(this, event.key === "Home" ? "FIRST" : "LAST");
          break;
        case " ":
          if (event.target === this.refs.search) return;
        case "Enter": {
          event.preventDefault();
          event.stopPropagation();
          if (event.repeat) return;
          const focusedItem = countryListItems.find((item) => item === document.activeElement && !item.closest("[hidden]"));
          if (focusedItem && focusedItem.dataset.value && countryInput && form) {
            countryInput.value = focusedItem.dataset.value;
            form.submit();
          }
          break;
        }
      }
    });
    __publicField(this, "selectCountry", (countryName, event) => {
      event.preventDefault();
      const { countryInput, countryListItems, form } = this.refs;
      if (!countryInput || !form || !countryListItems.some((item) => item.dataset.value === countryName && !item.closest("[hidden]"))) return;
      countryInput.value = countryName;
      form == null ? void 0 : form.submit();
    });
    __privateAdd(this, _onSearchKeyDown, (event) => {
      if (event.isComposing) return;
      if (event.key === "Enter") {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      __privateGet(this, _onContainerKeyDown).call(this, event);
    });
    __publicField(this, "focusSearchInput", () => {
      const target = this.refs.search || this.refs.countryList || this.refs.languageInput;
      target == null ? void 0 : target.focus();
    });
    __privateAdd(this, _onCountryListScroll, (event) => {
      const countryFilter = this.querySelector(".country-filter");
      const countryList = event.target instanceof HTMLElement ? event.target : null;
      if (countryFilter && countryList) {
        const shouldShowBorder = countryList.scrollTop > 0;
        countryFilter.classList.toggle("is-scrolled", shouldShowBorder);
      }
    });
  }
  connectedCallback() {
    super.connectedCallback();
    this.refs.search && this.refs.search.addEventListener("keydown", __privateGet(this, _onSearchKeyDown));
    this.refs.countryList && this.refs.countryList.addEventListener("keydown", __privateGet(this, _onContainerKeyDown));
    this.refs.countryList && this.refs.countryList.addEventListener("scroll", __privateGet(this, _onCountryListScroll));
    clearTimeout(this.localizationResizeTimer);
    this.localizationResizeTimer = setTimeout(() => {
      if (this.isConnected) this.resizeLanguageInput();
    }, 0);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    clearTimeout(this.localizationResizeTimer);
    this.refs.search && this.refs.search.removeEventListener("keydown", __privateGet(this, _onSearchKeyDown));
    this.refs.countryList && this.refs.countryList.removeEventListener("keydown", __privateGet(this, _onContainerKeyDown));
    this.refs.countryList && this.refs.countryList.removeEventListener("scroll", __privateGet(this, _onCountryListScroll));
  }
  /**
   * Changes the language of the localization form.
   *
   * @param {Event} event - The event object.
   */
  changeLanguage(event) {
    const { form, languageInput } = this.refs;
    const value = event.target instanceof HTMLSelectElement ? event.target.value : null;
    if (value) {
      languageInput.value = value;
      this.resizeLanguageInput();
      form.submit();
    }
  }
  resizeLanguageInput() {
    const { languageInput } = this.refs;
    if (!languageInput || CSS.supports("field-sizing", "content")) return;
    for (const option of languageInput.options) {
      if (!option.selected) {
        option.dataset.optionLabel = option.textContent || "";
        option.innerText = "";
      }
    }
    languageInput.style.width = "fit-content";
    const originalElementWidth = "".concat(Math.ceil(languageInput.offsetWidth) + 1, "px");
    if (languageInput.offsetWidth > 0) {
      languageInput.style.width = originalElementWidth;
    }
    for (const option of languageInput.options) {
      if (option.dataset.optionLabel) {
        option.textContent = option.dataset.optionLabel;
        delete option.dataset.optionLabel;
      }
    }
  }
  /**
   * Filters the countries based on the search value.
   */
  filterCountries() {
    const { countryList, countryListItems, liveRegion, noResultsMessage, popularCountries, resetButton, search } = this.refs;
    const { labelResultsCount } = this.dataset;
    const searchValue = normalizeString(search.value.trim());
    let countVisibleCountries = 0;
    resetButton.toggleAttribute("hidden", !searchValue);
    if (popularCountries) {
      popularCountries.toggleAttribute("hidden", Boolean(searchValue));
    }
    const wrapper = this.querySelector(".country-selector-form__wrapper");
    if (wrapper) {
      wrapper.classList.toggle("is-searching", !!searchValue);
    }
    for (const countryEl of countryListItems) {
      countryEl.setAttribute("aria-selected", "false");
      if (searchValue === "") {
        countryEl.removeAttribute("hidden");
        const countrySpan = countryEl.querySelector(".country");
        if (countrySpan) {
          countrySpan.textContent = countrySpan.textContent;
        }
      } else {
        const matches = __privateMethod(this, _LocalizationFormComponent_instances, findMatches_fn).call(this, searchValue, countryEl);
        if (matches.label || matches.alias || matches.iso || matches.currency) {
          countryEl.removeAttribute("hidden");
          const countrySpan = countryEl.querySelector(".country");
          if (countrySpan) {
            countrySpan.innerHTML = __privateMethod(this, _LocalizationFormComponent_instances, highlightMatches_fn).call(this, countrySpan.textContent, searchValue);
          }
        } else {
          countryEl.setAttribute("hidden", "");
        }
      }
    }
    countVisibleCountries = new Set(countryListItems.filter((item) => !item.hasAttribute("hidden") && !(popularCountries && popularCountries.hidden && popularCountries.contains(item))).map((item) => item.dataset.value)).size;
    search.removeAttribute("aria-activedescendant");
    if (liveRegion && labelResultsCount) {
      liveRegion.innerText = labelResultsCount.replace("[count]", "".concat(countVisibleCountries));
    }
    noResultsMessage.hidden = countVisibleCountries > 0;
    countryList.scrollTop = 0;
  }
  /**
   * Resets the countries filter.
   *
   * @param {Event} event - The event object.
   */
  resetCountriesFilter(event) {
    const { search } = this.refs;
    event.preventDefault();
    event.stopPropagation();
    search.value = "";
    this.filterCountries();
    search.setAttribute("aria-activedescendant", "");
    search.focus();
  }
  /**
   * Resets the form.
   */
  resetForm() {
    const { search } = this.refs;
    if (!search) return;
    if (search.value != "") {
      search.value = "";
      this.filterCountries();
      search.setAttribute("aria-activedescendant", "");
    }
  }
}
_onContainerKeyDown = /* @__PURE__ */ new WeakMap();
_LocalizationFormComponent_instances = /* @__PURE__ */ new WeakSet();
findMatches_fn = function(searchValue, countryEl, options = {
  // Which data types (label, alias, iso) to match against
  matchLabel: true,
  matchAlias: true,
  matchIso: true,
  matchCurrency: true,
  // If true, the search value must match the start of the label
  labelMatchStart: false,
  // If true, a result will not display unless the search value equals an alias in its entirety
  aliasExactMatch: false
}) {
  var _a, _b, _c, _d;
  let matchTypes = {};
  const { aliases, value: iso } = countryEl.dataset;
  if (options.matchLabel) {
    const countryName = normalizeString((_b = (_a = countryEl.querySelector(".country")) == null ? void 0 : _a.textContent) != null ? _b : "");
    if (!countryName) return matchTypes;
    matchTypes.label = options.labelMatchStart ? countryName.startsWith(searchValue) : countryName.includes(searchValue);
  }
  if (options.matchCurrency) {
    const currency = normalizeString((_d = (_c = countryEl.querySelector(".localization-form__currency")) == null ? void 0 : _c.textContent) != null ? _d : "");
    matchTypes.currency = currency.includes(searchValue);
  }
  if (options.matchIso) {
    matchTypes.iso = normalizeString(iso != null ? iso : "") == searchValue;
  }
  if (options.matchAlias) {
    const countryAliases = aliases == null ? void 0 : aliases.split(",").map((alias) => normalizeString(alias));
    if (!countryAliases) return matchTypes;
    matchTypes.alias = countryAliases.length > 0 && countryAliases.find(
      (alias) => options.aliasExactMatch ? alias === searchValue : alias.startsWith(searchValue)
    ) !== void 0;
  }
  return matchTypes;
};
highlightMatches_fn = function(text, searchValue) {
  if (!text || !searchValue) return text != null ? text : "";
  const normalizedText = normalizeString(text);
  const normalizedSearch = normalizeString(searchValue);
  const startIndex = normalizedText.indexOf(normalizedSearch);
  if (startIndex === -1) return text;
  const endIndex = startIndex + normalizedSearch.length;
  const before = text.slice(0, startIndex);
  const match = text.slice(startIndex, endIndex);
  const after = text.slice(endIndex);
  let result = "";
  if (before) {
    result += "<mark>".concat(before, "</mark>");
  }
  result += match;
  if (after) {
    result += "<mark>".concat(after, "</mark>");
  }
  return result;
};
changeCountryFocus_fn = function(direction) {
  const { countryListItems } = this.refs;
  const focusableItems = countryListItems.filter((item) => !item.closest("[hidden]"));
  const focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
  let itemToFocus;
  if (direction === "FIRST") {
    itemToFocus = focusableItems[0];
  } else if (direction === "LAST") {
    itemToFocus = focusableItems[focusableItems.length - 1];
  } else if (direction === "UP") {
    itemToFocus = focusedItemIndex > 0 ? focusableItems[focusedItemIndex - 1] : focusableItems[focusableItems.length - 1];
  } else {
    itemToFocus = focusedItemIndex < focusableItems.length - 1 ? focusableItems[focusedItemIndex + 1] : focusableItems[0];
  }
  for (const item of countryListItems) item.setAttribute("aria-selected", "false");
  itemToFocus == null ? void 0 : itemToFocus.setAttribute("aria-selected", "true");
  itemToFocus == null ? void 0 : itemToFocus.focus();
  if (this.refs.search) {
    if (itemToFocus) this.refs.search.setAttribute("aria-activedescendant", itemToFocus.id);
    else this.refs.search.removeAttribute("aria-activedescendant");
  }
};
_onSearchKeyDown = /* @__PURE__ */ new WeakMap();
_onCountryListScroll = /* @__PURE__ */ new WeakMap();
class DropdownLocalizationComponent extends Component {
  constructor() {
    super(...arguments);
    __privateAdd(this, _DropdownLocalizationComponent_instances);
    __publicField(this, "hidePanel", () => {
      var _a, _b;
      this.localizationOpenVersion = (this.localizationOpenVersion || 0) + 1;
      if (this.isHidden) return;
      this.removeEventListener("keyup", __privateGet(this, _handleKeyUp));
      document.removeEventListener("click", __privateGet(this, _handleClickOutside));
      (_a = this.refs.button) == null ? void 0 : _a.setAttribute("aria-expanded", "false");
      this.refs.panel.setAttribute("hidden", "");
      (_b = this.refs.localizationForm) == null ? void 0 : _b.resetForm();
    });
    __privateAdd(this, _handleClickOutside, (event) => {
      if (isClickedOutside(event, this)) {
        this.hidePanel();
      }
    });
    __privateAdd(this, _handleKeyUp, (event) => {
      var _a;
      switch (event.key) {
        case "Escape":
          this.hidePanel();
          event.stopPropagation();
          (_a = this.refs.button) == null ? void 0 : _a.focus();
          break;
      }
    });
  }
  get isHidden() {
    return this.refs.panel.hasAttribute("hidden");
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.localizationOpenVersion = (this.localizationOpenVersion || 0) + 1;
    this.removeEventListener("keyup", __privateGet(this, _handleKeyUp));
    document.removeEventListener("click", __privateGet(this, _handleClickOutside));
  }
  /**
   * Toggles the panel.
   */
  toggleSelector() {
    return this.isHidden ? this.showPanel() : this.hidePanel();
  }
  /**
   * Shows the panel.
   */
  showPanel() {
    if (!this.isHidden) return;
    this.addEventListener("keyup", __privateGet(this, _handleKeyUp));
    document.addEventListener("click", __privateGet(this, _handleClickOutside));
    this.refs.panel.removeAttribute("hidden");
    this.refs.button.setAttribute("aria-expanded", "true");
    const version = this.localizationOpenVersion = (this.localizationOpenVersion || 0) + 1;
    onAnimationEnd(this.refs.panel, () => {
      var _a;
      if (!this.isConnected || this.isHidden || this.localizationOpenVersion !== version) return;
      __privateMethod(this, _DropdownLocalizationComponent_instances, updateWidth_fn).call(this);
      (_a = this.refs.localizationForm) == null ? void 0 : _a.focusSearchInput();
    });
  }
}
_handleClickOutside = /* @__PURE__ */ new WeakMap();
_DropdownLocalizationComponent_instances = /* @__PURE__ */ new WeakSet();
updateWidth_fn = function() {
  this.style.setProperty("--width", "".concat(this.refs.localizationForm.offsetWidth, "px"));
};
_handleKeyUp = /* @__PURE__ */ new WeakMap();
class DrawerLocalizationComponent extends Component {
  constructor() {
    super(...arguments);
    __privateAdd(this, _onCountryListScroll2, (event) => {
      const countryFilter = this.querySelector(".country-filter");
      const countryList = event.target instanceof HTMLElement ? event.target : null;
      if (countryFilter && countryList) {
        const shouldShowBorder = countryList.scrollTop > 0;
        countryFilter.classList.toggle("is-scrolled", shouldShowBorder);
      }
    });
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.localizationOpenVersion = (this.localizationOpenVersion || 0) + 1;
    if (this.localizationScrollTarget) this.localizationScrollTarget.removeEventListener("scroll", __privateGet(this, _onCountryListScroll2));
    this.localizationScrollTarget = null;
  }
  /**
   * Toggles the dialog.
   *
   * @param {ToggleEvent} event - The event object.
   */
  toggle(event) {
    const { target } = event;
    const { localizationForm } = this.refs;
    if (!localizationForm || !(target instanceof HTMLDetailsElement)) return;
    const version = this.localizationOpenVersion = (this.localizationOpenVersion || 0) + 1;
    if (this.localizationScrollTarget) this.localizationScrollTarget.removeEventListener("scroll", __privateGet(this, _onCountryListScroll2));
    this.localizationScrollTarget = null;
    const countryList = localizationForm.querySelector(".country-selector-form__wrapper");
    if (target.open) {
      if (countryList) countryList.addEventListener("scroll", __privateGet(this, _onCountryListScroll2));
      this.localizationScrollTarget = countryList;
      onAnimationEnd(target, () => {
        if (this.isConnected && target.open && this.localizationOpenVersion === version) localizationForm.focusSearchInput();
      });
    } else {
      countryList == null ? void 0 : countryList.removeEventListener("scroll", __privateGet(this, _onCountryListScroll2));
      localizationForm.resetForm();
    }
  }
}
_onCountryListScroll2 = /* @__PURE__ */ new WeakMap();
if (!customElements.get("localization-form-component")) {
  customElements.define("localization-form-component", LocalizationFormComponent);
}
if (!customElements.get("dropdown-localization-component")) {
  customElements.define("dropdown-localization-component", DropdownLocalizationComponent);
}
if (!customElements.get("drawer-localization-component")) {
  customElements.define("drawer-localization-component", DrawerLocalizationComponent);
}
